module.exports = __webpack_public_path__ + "img/mtt_4.2.0b3cfa9e.png";